




































































































































































































































import { Vue, Component, Inject, Ref } from 'vue-property-decorator';
import smoothscroll from 'smoothscroll-polyfill';
import {
    ChessboardApiResponse,
    FlatFilters,
    ScrollState,
    Housing,
    Flat,
    Section,
} from './types';
import { http } from '@/http';
import { range } from './helpers/range';
import { dragscroll } from '@/directives/dragscroll-fork';
import { feedbackWidget } from '@/common/widgets';
import Modal, { ModalLinePrimary, ModalLineSecondary } from '@/components/Modal';
import Spinner from '@/components/Spinner';
import SvgIcon from '@/components/SvgIcon';
import Picture from '@/components/Picture/Picture.vue';
import Button from '@/components/Controls/Button';
import Checkbox from '@/components/Controls/Checkbox';
import FlatProperty from './FlatProperty.vue';

smoothscroll.polyfill();

@Component({
    components: {
        Spinner,
        SvgIcon,
        Picture,
        Button,
        Checkbox,
        Modal,
        ModalLinePrimary,
        ModalLineSecondary,
        FlatProperty,
    },

    directives: { dragscroll },

    filters: {
        flatTypeHumanizeShort(value: number) {
            switch (value) {
                case 0:
                    return 'Ст';
                default:
                    return value;
            }
        },
        flatTypeHumanize(value: number) {
            switch (value) {
                case 0:
                    return 'Студия';
                case 1:
                    return 'Однокомнатная квартира';
                case 2:
                    return 'Двухкомнатная квартира';
                default:
                    return value;
            }
        },
    },
})
export default class Chessboard extends Vue {
    /**
     *
     */
    @Inject()
    public readonly fetchHousingUrl!: string;
    /**
     *
     */
    @Inject()
    public readonly options!: any;
    /**
     *
     */
    @Inject()
    public readonly reserverdFlatModalData!: any;
    /**
     *
     */
    @Ref()
    public readonly scroller!: HTMLElement;
    /**
     *
     */
    @Ref()
    public readonly box!: HTMLElement;
    /**
     *
     */
    public scrollState: ScrollState = {
        canScrollToLeft: false,
        canScrollToRight: false,
        hasScroll: false,
    };
    /**
     *
     */
    public filterState: Record<number, boolean> = {};
    /**
     *
     */
    public filters: FlatFilters = [];
    /**
     *
     */
    public housing: Housing = {} as Housing;
    /**
     *
     */
    public showModal: boolean = false;
    /**
     *
     */
    public modalData: Record<string, any> = {};
    /**
     *
     */
    public get mustFilter() {
        return Object.values(this.filterState).filter(Boolean).length > 0;
    }
    /**
     *
     */
    public getFloors(section: Section) {
        const { floorsInSection, flatsInFloor, floors } = section || {};

        const result = range(2, floorsInSection).reduceRight((prev, curr) => {
            const floor = {
                number: curr,
                flats: range(1, flatsInFloor).reduce((prev, current) => {
                    const flat = floors?.[curr]?.flats?.[current] || {};
                    flat._isClickable = this.isFlatClickable(flat);
                    flat._isAvailable = this.isFlatAvailable(flat);
                    flat.floor = curr;
                    return [...prev, flat];
                }, [] as unknown[]),
            };

            return { ...prev, [curr]: floor };
        }, {});

        return Object.values(result).reverse();
    }
    /**
     *
     */
    public isFlatClickable(flat: any = {}) {
        if (!Object.keys(flat).length || flat.status === 'sold') {
            return false;
        }

        return true;
    }
    /**
     *
     */
    public isFlatAvailable(flat = {}) {
        return flat.hasOwnProperty('type') && !flat.hasOwnProperty('status');
    }
    /**
     *
     */
    public isPickedFlat(flatId: string) {
        flatId = String(flatId);
        const pickedFlatId = this.$route.query.flatId;
        const isArray = Array.isArray(pickedFlatId);
        return (
            pickedFlatId == flatId || (isArray && pickedFlatId.includes(flatId)) || false
        );
    }
    /**
     *
     */
    public updateFilterState(key: number, value: boolean) {
        this.filterState[key] = value;
        const { flatType: _, ...rest } = this.$route.query;

        const flatType = Object.entries(this.filterState).reduce((prev, curr) => {
            if (curr[1]) {
                return [...prev, curr[0]];
            } else {
                return prev;
            }
        }, [] as string[]);

        this.$router.replace({ query: { flatType, ...rest } });
    }
    /**
     *
     */
    public async fetchHousing() {
        try {
            const { data } = await http.get<ChessboardApiResponse>(this.fetchHousingUrl);

            this.housing = data.housing;
            this.filters = data.filters;
            this.filterState = this.filters.reduce(
                (prev, curr) => ({
                    ...prev,
                    [curr.flatType]:
                        this.$route.query.flatType == String(curr.flatType) ||
                        this.$route.query.flatType?.includes(String(curr.flatType)) ||
                        false,
                }),
                {}
            );
        } catch (error) {
            this.$errorLog(error);
        }
    }
    /**
     *
     */
    public onTransitionEnter() {
        this.onScroll();
        this.scrollPickedIntoViewIfNeed();
    }
    /**
     *
     */
    public onTransitionAfterEnter() {
        document.body.classList.add('chessboard-page-ready');
    }
    /**
     *
     */
    public async scrollPickedIntoViewIfNeed() {
        if (!this.$route.query.flatId) {
            return;
        }

        await this.$nextTick();

        this.$el
            .querySelector('.chessboard__cell--picked')
            ?.scrollIntoView({ block: 'center', inline: 'center' });
    }
    /**
     *
     */
    public onClickFlat(flat: Flat) {
        if (flat.status === 'reserved') {
            const modalData = this.$enrichVars(this.reserverdFlatModalData || {}, {
                $flat: flat,
            });

            feedbackWidget.show(modalData);
            return;
        }

        this.modalData = flat;
        this.showModal = true;
    }
    /**
     *
     */
    public closeModal() {
        this.modalData = {};
        this.showModal = false;
    }
    /**
     *
     */
    public scrollTo(direction: string) {
        const scroller = this.scroller;
        const scrollDistance = scroller.clientWidth / 2;

        switch (direction) {
            case 'left':
                scroller.scrollTo({
                    left: scroller.scrollLeft - scrollDistance,
                    behavior: 'smooth',
                });
                break;
            case 'right':
                scroller.scrollTo({
                    left: scroller.scrollLeft + scrollDistance,
                    behavior: 'smooth',
                });
                break;
        }
    }
    /**
     *
     */
    public onScroll() {
        const scroller = this.scroller;
        const box = this.box;

        this.scrollState.canScrollToLeft = scroller.scrollLeft > 60;
        this.scrollState.canScrollToRight =
            scroller.scrollLeft < box.clientWidth - scroller.clientWidth - 60;
        this.scrollState.hasScroll = box.clientWidth > scroller.clientWidth;
    }
    /**
     *
     */
    public async created() {
        this.$wait.start('fetchHousing');
        await this.fetchHousing();
        this.$wait.end('fetchHousing');
    }
}
